import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ComingSoonPage({ title }: { title: string }) {
  return (
    <Card>
      <CardHeader><CardTitle>{title}</CardTitle></CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">This feature is coming soon.</p>
      </CardContent>
    </Card>
  )
}
